export default __webpack_public_path__ + "static/media/background-bottom-left.5e3c42e8.png";